<template>
  <div>
    <h6 class="text-two">
      {{ question.semiology_form_question_type_description }}
    </h6>
    <div
      class="form-check"
      v-for="(item, key) in question.alternatives"
      :key="key"
    >
      <input
        class="form-check-input"
        type="radio"
        :id="`answer-${item.id}`"
        :name="`${category_id}-${question.id}-answer`"
        :value="item.id"
        @input="emit($event.target.value)"
      />
      <label class="form-check-label" :for="`answer-${item.id}`">
        {{ item.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: {
    category_id: [Number, String],
    question: Object,
  },
  methods: {
    emit(answer) {
      this.$emit("answer", {
        category_id: this.category_id,
        id: this.question.id,
        answer,
      });
    },
  },
};
</script>
